import { Box, Grid, Tooltip } from '@mui/material';
import {
    DataGrid,
    esES,
    GridValidRowModel,
    GridColDef,
} from '@mui/x-data-grid';
import { TableProps, TableTooltipProps } from './props';

export const TableTooltip = ({ value, children, align }: TableTooltipProps) => {
    return (
        <Tooltip title={value || ''} arrow>
            <Grid
                display="flex"
                alignItems={
                    align === 'left'
                        ? 'start'
                        : align === 'right'
                            ? 'end'
                            : 'center'
                }
                style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {children || value}
            </Grid>
        </Tooltip>
    );
};

export function Table<T extends GridValidRowModel>({
    rows,
    columns,
    paginationModel,
    rowCount,
    loading,
    pageSizeOptions = [5, 20, 50, 100],
    onFilterModelChange,
    onPaginationModelChange,
    checkboxSelection,
    disableRowSelectionOnClick,
    onRowClick,
    onRowSelectionModelChange,
    autoAdjustHeight, //Adjust the height table to the content
}: TableProps<T> & { autoAdjustHeight?: boolean }) {
    const enhancedColumns = columns.map((col: GridColDef) => ({
        ...col,
        renderCell: col.renderCell
            ? col.renderCell
            : (params: any) => (
                <TableTooltip value={params.value || ''} align={col.align} />
            ),
    }));

    return (
        <Box mt={2.5}>
            <DataGrid
                localeText={{
                    ...esES.components.MuiDataGrid.defaultProps.localeText,
                    noRowsLabel: 'Sin datos disponibles',
                }}
                rows={rows || []}
                columns={enhancedColumns}
                autoHeight
                getRowHeight={autoAdjustHeight ? () => 'auto' : undefined}
                paginationModel={paginationModel}
                rowCount={rowCount}
                paginationMode="server"
                loading={loading}
                pageSizeOptions={pageSizeOptions}
                onFilterModelChange={onFilterModelChange}
                onPaginationModelChange={onPaginationModelChange}
                checkboxSelection={checkboxSelection}
                disableRowSelectionOnClick={disableRowSelectionOnClick}
                onRowClick={onRowClick}
                onRowSelectionModelChange={onRowSelectionModelChange}
                sx={{
                    '.MuiTablePagination-displayedRows': {
                        marginTop: '1rem',
                    },
                    '.MuiTablePagination-selectLabel': {
                        marginTop: '1rem',
                    },
                    '.MuiDataGrid-columnHeaders': {
                        color: 'primary.contrastText',
                        backgroundColor: 'primary.main',
                    },
                    '.MuiDataGrid-columnHeaderCheckbox': {
                        color: 'primary.contrastText',
                        backgroundColor: 'primary.main',
                        '& .MuiCheckbox-root': {
                            color: 'primary.contrastText',
                        },
                    },
                    '.css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root': {
                        color: 'primary.contrastText',
                    },
                    '.MuiDataGrid-iconSeparator': {
                        color: 'primary.contrastText',
                    },
                    '.css-1i1c21g-MuiButtonBase-root-MuiButton-root': {
                        color: 'primary.main',
                    },
                    '.MuiCircularProgress-root': {
                        color: 'primary.main',
                    },
                    '.MuiDataGrid-row': {
                        cursor: onRowClick ? 'pointer' : 'auto',
                    },
                }}
            />
        </Box>
    );
}
